
import dust from "dustjs-linkedin";


(function(){dust.register("account/help",body_0);function body_0(chk,ctx){return chk.write("<section class=\"help\"><p class=\"error-message\"></p><p class=\"success-message\"></p></section>");}return body_0;})();

export default 0;
